import { render } from "./Conteudo.vue?vue&type=template&id=057f0491&scoped=true"
import script from "./Conteudo.vue?vue&type=script&lang=js"
export * from "./Conteudo.vue?vue&type=script&lang=js"

import "./Conteudo.vue?vue&type=style&index=0&id=057f0491&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057f0491"]])

export default __exports__